import React, { Component } from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"
import SettingsHeader from "../components/settings_header"
import SettingsDashboard from "../components/settings_dashboard"
import { makeToast } from "../util/toast_util"

class Settings extends Component {
    constructor(props) {
        super(props)
    }

    setSelectedSettingsTab = selectedSettingsTab =>
        this.props.setSelectedSettingsTab(selectedSettingsTab)

    handleCancelPlan = () => {
        // toast
        const msg = `Are you sure you want to cancel your plan?`
        const ind = "warning"
        const action = {
            text: "YES",
            onClick: this.props.handleCancelPlan,
        }
        makeToast(msg, ind, action)
    }

    handleChangePaymentMethod = (name, stripe) =>
        this.props.handleChangePaymentMethod(name, stripe)

    render() {
        const {
            ui: { selectedSettingsTab, paymentModalOpen },
            selectedTeamMembership,
            selectedTeamInvites,
            customer,
            isLoading,
            profile,
            changePassword,
            updateUserName,
            updateUserTimezone,
            updateNotificationPreferences,
            setPaymentModalOpen,
            ui,
            accounts,
            updateAccountName,
            oauth: { oAuthTokens },
            googleCalendarConfigs,
            zoomConfigs,
            teams,
            tags,
        } = this.props
        
        return (
            <div className="settings" id="settings-scroller">
                <SettingsHeader />
                <div className="settings-dashboard-container">
                    <SettingsDashboard
                        setSelectedSettingsTab={this.setSelectedSettingsTab}
                        selectedSettingsTab={selectedSettingsTab}
                        selectedTeamMembership={selectedTeamMembership}
                        selectedTeamInvites={selectedTeamInvites}
                        customer={customer}
                        handleCancelPlan={this.handleCancelPlan}
                        handleChangePaymentMethod={
                            this.handleChangePaymentMethod
                        }
                        paymentModalOpen={paymentModalOpen}
                        isLoading={isLoading}
                        profile={profile}
                        changePassword={changePassword}
                        updateUserName={updateUserName}
                        updateUserTimezone={updateUserTimezone}
                        updateNotificationPreferences={updateNotificationPreferences}
                        setPaymentModalOpen={setPaymentModalOpen}
                        ui={ui}
                        accounts={accounts}
                        updateAccountName={updateAccountName}
                        oAuthTokens={oAuthTokens}
                        googleCalendarConfigs={googleCalendarConfigs}
                        teams={teams}
                        tags={tags}
                        zoomConfigs={zoomConfigs}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return state
}

export default connect(
    mapStateToProps,
    actionCreators,
)(Settings)



// WEBPACK FOOTER //
// ./src/pages/settings.jsx